module.exports = __webpack_public_path__ + "img/gm_download.5591ac82.png";